import { Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Button, Pdf, Text } from '../../Atoms';
import PageTitle from '../../Components/Dashboard/PageTitle';
import { COLOR_BUTTON } from '../../Config/Config';
import { DetailDocument } from '../../Molecules';

const RENONCIATION_URL = 'https://www.cgrm.com/droit-de-renonciation';
const RESILIATION_URL = 'https://www.cgrm.com/resiliation';

export default function TemplateDocumentGaranties(props) {
  const container = useSelector((state) => state.container);
  function templateClassName() {
    const className = [
      ' template-container',
      'template-send-document',
      'template-scroll'
    ];
    if (container.padding === false) {
      className.push('mobile-content-nopadding');
    }
    return className.join(' ');
  }
  return (
    <div className={templateClassName()}>
      <PageTitle titleText={props.name} />
      {props.state.step === 1 && (
        <div className="content-template-type-document-container">
          {props?.state?.empty ? (
            <Text
              text="Vous n’avez pas de document disponible"
              className="title-send-document"
            />
          ) : (
            <>
              <Row>
                {props.state.docList.map((el, index) => (
                  <Col xs={12} md={6} className="" key={String(index + 1)}>
                    <DetailDocument
                      text={el.name}
                      onViewFile={() => props.onOpen(el)}
                      onDownload={() => props.onDowLoad(el)}
                    />
                  </Col>
                ))}
              </Row>
              {props?.withNotice && !!props.state.docList?.length && (
                <p style={{ fontFamily: 'Mont' }}>
                  Ce document n'est pas contractuel. Veuillez consulter la
                  notice de l'assureur disponible dans votre bibliothèque
                  'documents entreprises' ou contacter votre interlocuteur des
                  ressources humaines.
                </p>
              )}
            </>
          )}
        </div>
      )}
      {props.state.step === 2 && (
        <div className="content-template-document-sended">
          <div className="container-doc-sended-step2"></div>
          <Pdf url={props.state.file.url} />
          <div
            className="container-btn-downlond-doc"
            style={{ paddingBottom: '50px' }}
          >
            <Button
              text="Télécharger"
              onClick={() => props.onDowLoad(props.state.documentSelected)}
              className="btn-downlond-doc"
              color={COLOR_BUTTON.SALMON}
            />
          </div>
        </div>
      )}
      {props.state.step === 1 && props?.withResiliateButton && (
        <div
          className="container-btn-resiliation-doc"
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexWrap: 'wrap',
            gap: '15px'
          }}
        >
          <Button
            type="primary"
            text="Renoncer à mon contrat"
            icon="Document"
            onClick={() => window.open(RENONCIATION_URL, '_blank', 'noopener,noreferrer')}
            className="btn-renonciation-doc"
            color={COLOR_BUTTON.GREEN}
          />
          <Button
            type="primary"
            text="Résilier mon contrat"
            icon="CloseIcon"
            onClick={() => window.open(RESILIATION_URL, '_blank', 'noopener,noreferrer')}
            className="btn-resiliation-doc"
            color={COLOR_BUTTON.GREEN}
            isAlreadyOutline
          />
        </div>
      )}
    </div>
  );
}
